import React, { memo } from 'react'
import {
  ClockIcon,
  CloseIcon,
  RefreshIcon,
  SuccessIcon,
  TodoListIcon,
  WarningIcon,
  ArrowBackIcon,
  BasicCloseIcon,
  LockIcon,
  InfoIcon,
  BasicSuccessIcon,
  BasicClockIcon,
  DownloadIcon,
  VisibilityIcon,
  VisibilityOffIcon,
  BookmarkIcon,
  FlagIcon,
  ShieldIcon,
  RecentActorsIcon,
  GavelIcon,
  FaceIcon,
  EncryptedIcon,
  ContentPasteIcon,
  BookmarkCheckIcon,
  PersonIcon,
  CheckmarkIcon,
  CheckbookIcon,
  ArticleIcon,
  BookIcon,
  AccountBalance,
  Bell,
  Drafts,
  Monetization,
  Copy,
  ChatIcon,
  ChevronDownIcon,
  SearchIcon,
  CloudIcon,
} from './icons'
import {
  BrasilIcon,
  EcuadorIcon,
  MexicoIcon,
  PeruIcon,
  UruguayIcon,
} from './flag-icons'
import { WidgetIconProps } from './widget-icon.d'
import { WatchLaterIcon } from './icons/watch-later-icon'

export const KEY_ICONS: string[] = [
  'article',
  'accountBalance',
  'bell',
  'copy',
  'drafts',
  'monetization',
  'success',
  'warning',
  'todoList',
  'refresh',
  'recentActors',
  'gavel',
  'face',
  'encrypted',
  'contentPaste',
  'bookmarkCheck',
  'close',
  'clock',
  'arrowBack',
  'basicClose',
  'lock',
  'info',
  'basicSuccess',
  'basicClock',
  'download',
  'visibility',
  'visibilityOff',
  'bookmark',
  'flag',
  'shield',
  'person',
  'checkmark',
  'checkbook',
  'search',
  'book',
  'chat',
  'chevronDown',
  'watchLater',
  'brasil',
  'ecuador',
  'mexico',
  'peru',
  'uruguay',
  'cloud',
]

export const getIcon = (
  name: string,
  color?: string,
  secondaryColor?: string
) => {
  const AVAILABLE_ICONS: Record<string, React.ReactElement> = {
    article: ArticleIcon(color),
    accountBalance: AccountBalance(color),
    bell: Bell(color),
    drafts: Drafts(color),
    copy: Copy(color),
    monetization: Monetization(color),
    success: SuccessIcon(color, secondaryColor),
    warning: WarningIcon(color, secondaryColor),
    todoList: TodoListIcon(color, secondaryColor),
    refresh: RefreshIcon(color, secondaryColor),
    close: CloseIcon(color, secondaryColor),
    recentActors: RecentActorsIcon(color),
    gavel: GavelIcon(),
    face: FaceIcon(color),
    encrypted: EncryptedIcon(color),
    contentPaste: ContentPasteIcon(color),
    bookmarkCheck: BookmarkCheckIcon(color),
    clock: ClockIcon(color, secondaryColor),
    watchLater: WatchLaterIcon(color),
    arrowBack: ArrowBackIcon(color),
    basicClose: BasicCloseIcon(color),
    lock: LockIcon(color),
    info: InfoIcon(color),
    basicSuccess: BasicSuccessIcon(color),
    basicClock: BasicClockIcon(color),
    download: DownloadIcon(color),
    visibility: VisibilityIcon(color),
    visibilityOff: VisibilityOffIcon(color),
    bookmark: BookmarkIcon(color),
    flag: FlagIcon(color),
    search: SearchIcon(color),
    shield: ShieldIcon(color),
    person: PersonIcon(color),
    checkmark: CheckmarkIcon(color),
    checkbook: CheckbookIcon(color),
    book: BookIcon(color),
    chat: ChatIcon(color),
    chevronDown: ChevronDownIcon(color),
    brasil: BrasilIcon(),
    ecuador: EcuadorIcon(),
    mexico: MexicoIcon(),
    peru: PeruIcon(),
    uruguay: UruguayIcon(),
    cloud: CloudIcon(color),
  }
  return AVAILABLE_ICONS[name]
}

export const WidgetIcon = memo((props: WidgetIconProps) => {
  const { name, color, secondaryColor, padding } = props

  if (KEY_ICONS.includes(name)) {
    return (
      <div
        data-testid="widget-icon-wrapper"
        style={{ display: 'flex', padding: padding }}
      >
        {getIcon(name, color, secondaryColor)}
      </div>
    )
  }
  return null
})

WidgetIcon.displayName = 'WidgetIcon'
